import React, { SVGProps } from 'react'
export const WomanAnonymousSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#2E2A29"
      d="M15.952 12.963c-.36-.221-.473-.664-.473-.963 0-3.6-2.445-4.833-3.667-5C7.57 7 5.97 8.94 5.366 11.006a1.5 1.5 0 1 1-.363 2.91C5 14.122 5 14.318 5 14.5c0 2.5 1.048 5 3.144 5 1.677 0 2.096 1.333 2.096 2v1.117a.817.817 0 0 1-.814.373C6 22.465 1.344 19.97 1.018 12.654.529 1.694 10.167.434 13.718 1.171l.308.063C17.546 1.954 23 3.068 23 14.22c0 2.515-1.262 7.053-6.826 8.468a.824.824 0 0 1-.769-.196c-.07-2.571.092-6.164 1.123-6.492 1.492-.475 2.04-3.202.746-3.05-.142-.123-.354-.161-.644-.068a1.538 1.538 0 0 1-.678.081Z"
    />
    <path fill="#2E2A29" d="M12 12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
  </svg>
)
